import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import { cleanInput } from "../../../helpers/cleanInput";
import { Beat } from "../../../plugins/spinners.plugin";
import Warning from "../../../assets/images/icons/warning.svg";
import { filterPromoCodes } from "../../../redux/promo/promoAction";

export default function FilterPromoDropDown({
  payLoad,
  isFilterOpen,
  setFilterState,
}) {
  const dispatch = useDispatch();
  const { isLoading, filtering } = useSelector((state) => state.promo);

  const [errorMsg, setErrorMsg] = useState(false);
  const [data, setData] = useState({
    title: "",
    expiry: "",
  });
  const { title, expiry } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };
  const handleReset = async () => {
    setData({
      title: "",
      // status: "",
      expiry: "",
    });
    await dispatch(filterPromoCodes(payLoad, 1));
    setFilterState(!isFilterOpen);
  };

  const handleSubmit = async () => {
    cleanInput(data);
    if (title || expiry) {
      setErrorMsg(false);
      let newData = { ...data, ...payLoad };
      console.log("newData", newData);
      try {
        const response = await dispatch(filterPromoCodes(newData, 1));
        if (response) {
          setFilterState(!isFilterOpen);
        }
      } catch (error) {
        console.log(error);
        setFilterState(!isFilterOpen);
      }
    } else {
      setErrorMsg(true);
    }
  };
  return (
    <>
      <div className="py-5 mt-4 px-5">
        <form className="text-left">
          <div className="grid grid-cols-1">
            <Input.Label
              title={"Title"}
              htmlFor={"title"}
              name={"title"}
              onChange={handleChange}
              autoComplete="off"
              value={title}
              placeholder={"Enter Title"}
            />
            {/* <Input.Select
              title={"Status"}
              name="status"
              htmlFor={"status"}
              value={status}
            >
              <option>Select a status</option>
              <option value={"active"}>Active</option>
              <option value={"inactive"}>Inactive</option>
            </Input.Select> */}

            <Input.DatePicker
              title={"Date"}
              htmlFor={"expiry"}
              name={"expiry"}
              autoComplete="off"
              value={expiry}
              onChange={handleChange}
            />

            <div className="py-8 grid grid-cols-2 gap-6 text-center">
              <Button.Secondary
                disabled={isLoading}
                title={isLoading ? <Beat color={"#ce2600"} /> : "Reset"}
                className="px-4"
                onClick={handleReset}
                type="button"
              />
              <Button.Primary
                disabled={filtering}
                title={filtering ? <Beat color={"#ffffff"} /> : "Filter"}
                className="px-4"
                onClick={handleSubmit}
                type="button"
              />
            </div>
          </div>
          {errorMsg && (
            <div className="flex gap-1 -mt-2">
              <img src={Warning} alt="warning" />
              <p>No value to filter by</p>
            </div>
          )}
        </form>
      </div>
    </>
  );
}
